import React from "react";
import StockRequisitionEditor from "./StockRequisitionEditor";

export default function AddStockRequisitionPopup({ isOpen, onClose, businessUnitId }) {
  return isOpen ? <StockRequisitionEditor key={businessUnitId} businessUnitId={businessUnitId} onClose={onClose} /> : null;
}
